// features/authSlice.js
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserState {
  authModal: {
    loginCompleted: boolean;
    passwordSection: boolean;
  };
  firstlogin: boolean;
  invitationCode: string;
  invitationProfileId: string;
  loading: boolean;
  params: {
    userEmail: string;
    verificationCode: string;
  };
}
const initialState: UserState = {
  authModal: {
    loginCompleted: false,
    passwordSection: false,
  },
  firstlogin: false,
  invitationCode: "",
  invitationProfileId: "",
  loading: false,
  params: {
    userEmail: "",
    verificationCode: "",
  },
};

const authSlice = createSlice({
  initialState,
  name: "auth",
  reducers: {
    firstlogin: (state, action: PayloadAction<boolean>) => {
      state.firstlogin = action.payload;
    },
    invitationCode: (state, action: PayloadAction<string>) => {
      state.invitationCode = action.payload;
    },
    passAuth: (
      state,
      action: PayloadAction<{
        loginCompleted: boolean;
        passwordSection: boolean;
      }>
    ) => {
      state.authModal = {
        loginCompleted: action.payload.loginCompleted,
        passwordSection: action.payload.passwordSection,
      };
    },
    passParams: (
      state,
      action: PayloadAction<{
        userEmail: string;
        verificationCode: string;
      }>
    ) => {
      state.params = {
        userEmail: action.payload.userEmail,
        verificationCode: action.payload.verificationCode,
      };
    },
    setInvitationProfileId: (state, action: PayloadAction<string>) => {
      state.invitationProfileId = action.payload;
    },
  },
});

export default authSlice;
